import { hooks } from '@yola/ws-sdk';
import availableHooks from './constants/available-hooks';

export default {
  onViewReady() {
    hooks.operations.trigger(availableHooks.ON_VIEW_READY);
  },
};
